import { createIcon } from '@chakra-ui/icons';

export const Mail = createIcon({
  displayName: 'Mail',
  viewBox: '0 0 16 17',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <g id="mail 2">
        <g id="Group">
          <path
            id="Vector"
            d="M14 1.5H2C0.895 1.5 0 2.395 0 3.5V13.5C0 14.605 0.895 15.5 2 15.5H14C15.105 15.5 16 14.605 16 13.5V3.5C16 2.395 15.105 1.5 14 1.5ZM14 13.5H2V7.223L7.504 10.368C7.812 10.544 8.189 10.544 8.496 10.368L14 7.223V13.5ZM14 4.92L8 8.349L2 4.92V3.5H14V4.92Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>,
  ],
});
